// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d70b5dbf","455":"375e3813","977":"7fde4655"}[chunkId] + ".chunk.js";
};